<template>
	<!-- Create evaluation question -->
	<ja-modal class="intro-modal" :show="show">
		<ja-close-button name="close" @click.native="cancel"></ja-close-button>
		<div class="tittle-section">
			<h2>{{ $t('addResource') }}</h2>
			<hr />
		</div>
		<div class="container-add-resource">
			<ja-input
				v-model="resource.name"
				:label="$t('resourceName')"
				:name="$t('resourceName')"
				required
			></ja-input>
			<ja-dropdown
				v-model="resourceCategoryIndex"
				:label="$t('resourceCategory')"
				:options="resource.categories"
				name="resourceCategory"
				required
			></ja-dropdown>
			<ja-input
				v-model="resource.description"
				:label="$t('resourceDescription')"
				:name="$t('resourceDescription')"
			></ja-input>

			<ja-input
				v-model="resource.link"
				:label="$t('resourceLink')"
				:name="$t('resourceLink')"
			></ja-input>
		</div>
		<div class="tittle-section">
			<h2>{{ $t('attachment') }}</h2>
			<hr />
		</div>
		<div class="select-file">
			<ja-button
				name="selectFile"
				class="small outlined"
				@click.native="openFileSelector"
				>{{ $t('selectFile') }}</ja-button
			>
			<span>{{ $t('or Drop File Here') }}</span>
			<input
				ref="fileInput"
				type="file"
				style="display: none;"
				accept=".pdf,.doc,.png,.jpg"
				@change="validateFile"
			/>
		</div>
		<div v-if="fileInfo" class="select-file  selection">
			<ja-button
				name="delete"
				class="outlined button-delete"
				@click.native="removeFile"
				>{{ 'X' }}</ja-button
			>
			<div class="file-info">
				<span>{{ fileInfo }}</span>
				<span v-if="fileValid" class="text--success">{{
					'File is uploaded and will be saved once you click the "Save" button. Click the "X" to remove the File if you want to add a Link.'
				}}</span>
				<span v-else class="text--warning">{{
					'File type is not allowed - allowed types are (pdf, doc, png, jpg)'
				}}</span>
			</div>
		</div>

		<span>{{
			'Choose one of the following file formats (pdf, doc, png, jpg) or paste a URL in the "Link" textbox.'
		}}</span>
		<div class="container-buttons save">
			<ja-button
				name="save"
				class="small outlined"
				:disabled="isValid && !fileValid"
				@click.native="saveResource"
				>{{ $t('save') }}</ja-button
			>
			<ja-button name="cancel" class="small" @click.native="cancel">{{
				$t('cancel')
			}}</ja-button>
		</div>
	</ja-modal>
</template>
<script>
import { Dropdown, Input } from '@/components/ui/form';
import Button from '@/components/ui/Button';
import Modal from '@/components/Modal/Modal';
import CloseButton from '@/components/ui/CloseButton';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';

export default {
	components: {
		jaDropdown: Dropdown,
		jaButton: Button,
		jaInput: Input,
		jaModal: Modal,
		jaCloseButton: CloseButton
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		createData: {
			type: Object,
			default: () => {},
			required: true
		}
	},
	data() {
		return {
			resource: null,
			fileInfo: null,
			fileValid: null,
			resourceCategoryIndex: 0
		};
	},
	computed: {},
	watch: {
		resourceCategoryIndex(newValue) {
			this.resource.category = this.resource.categories[newValue];
		}
	},
	created() {
		this.resource = this.createData;
		this.resource.category = this.resource.categories[
			this.resourceCategoryIndex
		];
		this.resource.facility_ID = this.selectedFacilityId;
		if (this.resource.file != null) {
			this.fileValid = true;
			this.fileInfo = this.resource.fileName;
		}
	},
	methods: {
		isValid() {
			return this.fileValid.name !== null && this.fileValid.file !== null;
		},
		openFileSelector() {
			this.$refs.fileInput.click();
		},
		formatFileSize(bytes) {
			const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
			if (bytes === 0) return '0 Byte';
			const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
			return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
		},
		async readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => {
					resolve(reader.result);
				};
				reader.onerror = reject;
				reader.readAsDataURL(file);
			});
		},
		async validateFile(event) {
			const input = event.target;
			const file = input.files[0];
			const allowedTypes = [
				'application/pdf',
				'application/msword',
				'image/png',
				'image/jpeg'
			];
			this.fileInfo = `${file.name} ${this.formatFileSize(file.size)}`;
			if (!allowedTypes.includes(file.type)) {
				this.fileValid = false;
				return;
			} else {
				const fileDataURL = await this.readFileAsync(file);
				this.resource.file = fileDataURL;
				this.resource.fileName = file.name;
				this.resource.fileType = file.type;
				this.fileValid = true;
			}
		},
		removeFile() {
			this.$refs.fileInput.value = '';
			this.fileInfo = null;
			this.fileValid = false;
			this.resource.file = null;
			this.resource.fileName = null;
			this.resource.fileType = null;
		},
		saveResource() {
			this.$emit('saveResource', this.resource);
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
<style lang="scss" scoped>
.container-buttons {
	margin: 15px 0 10px 0;
	display: flex;
	align-items: center;
	gap: 20px;
}
::v-deep .modal {
	padding: 50px;
}
.save {
	justify-content: flex-end;
}
.container-add-resource {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 10px;
	margin-top: 20px;
}
.select-file {
	display: flex;
	align-items: baseline;
	gap: 20px;
	margin: 20px 0 30px;
}
.selection {
	align-items: center;
}
.heading-5 {
	color: $font-dark;
}
.text-button {
	color: $link-font-color;
}
.text-label {
	margin: 10px 0 10px 0;
}
.file-info {
	display: flex;
	flex-direction: column;
	gap: 5px;
}
.button-delete {
	border-radius: 5px;
	width: 30px;
	height: 30px;
}
</style>
